/**
 * ********************************************************************
 * Overlay manager with text message
 *  - an overlay layer with spinner and text message
 * ********************************************************************
 */
module.exports = {
    show: function (text) {
        if ($('.overlay').length < 1) {
            $('body').append('<span class="overlay"><span class="in-progress"><i class="fa fa-spinner fa-spin"></i> ' + text + '</span></span>');
        }
    },
    hideAll: function (){
        $('.overlay').remove();
    }
};